import React from 'react';
import CameraCapture from './CameraCapture';

interface Props {
  onCapture: (blob: Blob) => void;
  onClear?: () => void;
  disabled?: boolean;
}

const DocumentCapture = ({ onCapture, onClear, disabled }: Props) => (
  <CameraCapture
    onCapture={onCapture}
    onClear={onClear}
    disabled={disabled}
    facingMode="environment"
    width={1280}
    height={960}
    previewObjectFit="contain"
    altText="Captured document"
  />
);

export default DocumentCapture;
